import { render } from "./FbSports.vue?vue&type=template&id=17ec6e6d&scoped=true"
import script from "./FbSports.vue?vue&type=script&lang=js"
export * from "./FbSports.vue?vue&type=script&lang=js"

import "./FbSports.vue?vue&type=style&index=0&id=17ec6e6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ec6e6d"]])

export default __exports__